import React, { FC } from "react";
import { Skeleton } from "antd";

const LineSkeletonLoader: FC = () => {
  return <Skeleton title active={true} paragraph={false} />;
};

export default LineSkeletonLoader;
